/** @internal */
export function getInputFileChangeFactory() {

    return [() => {

        return {
            restrict: "A",

            link: function(scope: ng.IScope, element, attrs) {

                var onChangeHandler: Function = scope.$eval(attrs.omniaInputFileChange);
                var thisArg = scope.$eval(attrs.thisArg);

                if (thisArg) {
                    onChangeHandler = onChangeHandler.bind(thisArg);
                }

                element.bind("change", onChangeHandler);

            }

        }

    }];

}
